module.exports = __webpack_public_path__ + "img/21_101.b5b5e3d7.png";